<div class="annual-status-wrapper">
  <div class="status" [class]="SigningStatus[status!]">
    {{ SigningStatus[status!] | splitByCapitalLetterPipe }}
  </div>
</div>
